import { compose, setDisplayName, setPropTypes, withProps } from 'recompose'
import PropTypes from 'prop-types'
import capitalize from 'lodash/capitalize'
import compact from 'lodash/compact'
import withPreviewAddressFromId from './withPreviewAddressFromId'

const withPreviewStreetAddress = compose(
  setDisplayName('withPreviewStreetAddress'),
  withPreviewAddressFromId,
  setPropTypes({
    address: PropTypes.shape({
      street: PropTypes.string.isRequired,
      unit: PropTypes.string,
      zip: PropTypes.string.isRequired,
    }).isRequired,
  }),
  withProps(({ address }) => {
    const { street, unit } = address
    const streetAddress = compact([
      street.split(' ').map(capitalize).join(' '),
      unit && `#${unit}`,
    ]).join(' ')
    return { streetAddress }
  })
)

export default withPreviewStreetAddress
